// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * Spec 20261103-140000 AC-3: one municipality as the address forms pick it. `value` is the IBGE code without the check
 * digit, the one Tasy and the stored forms hold; `rn` and `total_rows` keep the names of the ORDS page the screens were
 * written against. Strict, so a field that starts leaking fails here.
 */
export const municipalityOptionSchema = z
    .object({
        value: z.string().regex(/^\d{6}$/),
        label: z.string().min(1),
        rn: z.number().int().positive(),
        total_rows: z.number().int().nonnegative(),
    })
    .strict()
export type MunicipalityOption = z.infer<typeof municipalityOptionSchema>

/** GET /api/internal-doctors/municipalities and GET /api/register/municipalities. */
export const municipalityPageSchema = z
    .object({ items: z.array(municipalityOptionSchema), hasMore: z.boolean() })
    .strict()
export type MunicipalityPage = z.infer<typeof municipalityPageSchema>
